function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("style", {
  type: "text/css"
}, "\n\t.st0{fill:none;stroke-width:2;stroke-miterlimit:10;}\n");

var _ref3 = /*#__PURE__*/React.createElement("polygon", {
  className: "st0",
  points: "61.9,17.7 74.4,6.9 75.6,21.8 106.5,5.3 85,32.6 109.8,29.2 87.1,46.8 97,57.8 81.1,59.8 96.5,90.4  69.1,67.6 61.4,78.7 54.7,67.6 27,88.4 42.7,59.8 5.3,62.7 36.7,46.8 19.1,34.1 38.7,32.6 23.4,9.9 48.1,21.8 53.1,3 "
});

var SvgDamage = function SvgDamage(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    x: "0px",
    y: "0px",
    viewBox: "0 0 113.9 94.6",
    style: {
      enableBackground: "new 0 0 113.9 94.6"
    },
    xmlSpace: "preserve",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgDamage, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/damage.b186fb17.svg";
export { ForwardRef as ReactComponent };